import { Injectable } from '@angular/core';
import { Observable, Subject, timer } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SessionTimerService {
  private destroy$ = new Subject<void>();
  constructor(private storage: StorageMap, private router: Router) {}

  private createSessionTimer(): Observable<number> {
    // return timer(SESSION_TIMEOUT_MS);
    return this.storage.get('maxsessionvalidtime').pipe(
      switchMap((maxSessionValidTime: number) => {
        const timeoutDuration = maxSessionValidTime * 60 * 1000;
        return timer(timeoutDuration);
      })
    );
  }

  

  public startSessionTimer(): void {
    this.createSessionTimer()
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => this.clearLocalStorageAndRedirect())
      )
      .subscribe();
  }

  private clearLocalStorageAndRedirect(): Observable<void> {
    return this.storage.clear().pipe(
      switchMap(() => {
        // Redirect to the homepage after clearing localStorage
        this.router.navigate(['/auth/login']);
        // Optionally, you can also perform additional logout or session expiration actions here
        return new Observable<void>((observer) => {
          observer.complete();
        });
      })
    );
  }

  public cancelSessionTimer(): void {
    this.destroy$.next();
  }

  public resetSession(): void {
    this.cancelSessionTimer();
    this.startSessionTimer();
  }
}
